export default {
  LAYOUT: {
    FOOTER: { TITLE: 'Footer' },
    MENU: {
      HOME: {
        TITLE: 'Home',
        DASHBOARD: 'Dashboard',
      },
      UI_COMPONENTS: {
        TITLE: 'UI Components',
        EXAMPLES: 'Theme test',
        CRUD: 'CRUD',
        TIMELINE: 'Timeline',
        FORM_LAYOUT: 'Form Layout',
        INPUT: 'Input',
        FLOAT_LABEL: 'Float Label',
        INVALID_STATE: 'Invalid State',
        BUTTON: 'Button',
        TABLE: 'Table',
        LIST: 'List',
        TREE: 'Tree',
        PANEL: 'Panel',
        OVERLAY: 'Overlay',
        MEDIA: 'Media',
        MENU: 'Menu',
        MESSAGE: 'Message',
        FILE: 'File',
        CHART: 'Chart',
        MISC: 'Misc',
      },
      UTILITIES: {
        TITLE: 'Utilities',
        PRIMENG: 'PrimeNG',
        PRIME_BLOCKS: 'PrimeBlocks',
        PRIME_ICONS: 'PrimeIcons',
        PRIME_FLEX: 'PrimeFlex',
        APEX_CHARTS: 'ApexCharts',
      },
      PAGES: {
        TITLE: 'Pages',
        LANDING: 'Landing',
        ERRORS: {
          TITLE: 'Errors',
          LOGIN: 'Login',
          ERROR: 'Error',
          ACCESS_DENIED: 'Access denied',
          NOT_FOUND: 'Not found',
        },
        EMPTY: 'Empty',
        PAGINATION: 'Pagination',
        LIST: 'List',
        TABLE: 'Table',
      },
      GET_STARTED: {
        TITLE: 'Get Started',
        DOCUMENTATION: 'Documentation',
        VIEW_SOURCE: 'View source',
      },
    },
    NAVBAR: {
      PROFILE: 'Profile',
      LANGUAGE: 'Language',
      LANGUAGES: {
        EN: 'English',
        ES: 'Spanish',
      },
      COMPANY: 'Company',
      DATA_MANAGEMENT: 'Settings',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'USER-MANAGEMENT': 'Users',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'ENTITY-LOCATION': 'Locations',
      APP_USERS: 'App users',
      SAAS_TRAINING: 'New SaaS users',
      CHANGE_PASSWORD: 'Change password',
      LOGOUT: 'Sign out',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'USER-ACTION-LOG': 'Action history',
      CONTACT: 'Contact wokap',
      AI_CONNECTOR: 'MCP | Connect with GPT or Claude',
      TUTORIAL: 'Help | Interactive guides',
      TUTORIALS: {
        GENERAL: 'General interactive guide',
        OFFERS: 'Offers interactive guide',
        CANDIDATES: 'Candidates interactive guide',
        OFFERS_DISABLED_TOOLTIP: 'This option will be enabled when you have offers',
        CANDIDATES_DISABLED_TOOLTIP: 'This option will be enabled when your offer has candidates',
        NO_CANDIDATES_MESSAGE: 'No offers with candidates were found. The guide will be enabled when you have candidates in an offer.',
      },
      MENU: 'Menu',
      TIKTOK: 'TikTok Demo',
    },
    SIDEBAR: { TITLE: 'Sidebar' },
  },
} as const;
